var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login el-reset" },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.form, rules: _vm.rules } },
        [
          _c("h2", { staticClass: "el-h2" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("vrlounge.loginToAccount")) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "username" } },
            [
              _c(
                "label",
                { staticClass: "el-label", attrs: { for: "username" } },
                [_vm._v(_vm._s(_vm.$t("general.username")))]
              ),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  name: "username",
                  placeholder: _vm.$t("general.username"),
                },
                model: {
                  value: _vm.form.username,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "username", $$v)
                  },
                  expression: "form.username",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "password" } },
            [
              _c(
                "label",
                { staticClass: "el-label", attrs: { for: "password" } },
                [_vm._v(_vm._s(_vm.$t("general.password")))]
              ),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  password: "",
                  name: "password",
                  "show-password": "",
                  placeholder: _vm.$t("general.password"),
                },
                model: {
                  value: _vm.form.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "password", $$v)
                  },
                  expression: "form.password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { "text-align": "end" } }, [
            _c(
              "a",
              {
                staticClass: "el-link",
                attrs: { href: _vm.forgotPasswordUrl, target: "__blank" },
              },
              [_vm._v(_vm._s(_vm.$t("general.forgetPassword")))]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "el-keep-login-row" }, [
        _c(
          "label",
          { staticClass: "el-checkbox-label", attrs: { for: "keeplogin" } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.isKeepLogin,
                  expression: "isKeepLogin",
                },
              ],
              staticClass: "el-checkbox",
              attrs: { id: "keeplogin", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.isKeepLogin)
                  ? _vm._i(_vm.isKeepLogin, null) > -1
                  : _vm.isKeepLogin,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.isKeepLogin,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.isKeepLogin = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.isKeepLogin = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.isKeepLogin = $$c
                  }
                },
              },
            }),
            _vm._v(_vm._s(_vm.$t("vrlounge.keepLogin"))),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "el-button",
          attrs: { loading: _vm.loading },
          on: { click: _vm.handleSubmit },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("general.login")) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }